import $ from 'jquery';

$(document).ready(function() {
  $('.js-museums-calendar').each(function() {
    $(this).dateRangePicker({
      singleDate : true,
      singleMonth: true,
      container: 'main',
    }).bind('datepicker-open', function() {
      if ($(window).width() > 1023) {
        if ($(".js-museums-calendar-value").text() !== "") {
          $('.js-museums-calendar-button').addClass('active');
        }
        let width = 0,
          widthCal = 0,
          offsetLeft = 0;
        width = $('.js-museums-calendar').width();
        widthCal = $('.date-picker-wrapper').width();
        offsetLeft = $('.js-museums-calendar').offset().left;
        $('.date-picker-wrapper').css('left', (offsetLeft + (width - widthCal)) + "px");
      }
    }).bind('datepicker-change', function(event,obj) {
      $('.js-museums-calendar-value').text(obj.value);
      if (obj.value !== "") {
        $('.js-museums-calendar-button').addClass('active');
        $('.js-museums-calendar-clear').addClass("active");
      }
    }).bind('datepicker-close', function() {
      $('.js-museums-calendar-button').removeClass('active');
    });
  });
  $('body').on('click', function(e) {
    if (!((e.target).closest('.js-museums-calendar-button'))) {
      $('.js-museums-calendar-button').removeClass('active');
    }
  });
});


// WEBPACK FOOTER //
// ./src/js/pages/museums/museums-calendar.js